<template>
    <div>
      <div class="col-12 lg:col-12 px-0">
        <Toolbar class="mb-2">
          <template #end>
            <Button
              label="Nuevo"
              icon="pi pi-plus"
              class="p-button-success mr-2"
              @click="agregarDispositivo"
            />
          </template>
        </Toolbar>
      </div>
  
      <DataTable
        :value="lstDispositivos"
        dataKey="Id_tipo_dispositivo"
        ref="dt"
        v-model:filters="filters"
        :globalFilterFields="['Descripcion']"
        :loading="loading"
        :paginator="true"
        :rows="20"
        responsiveLayout="scroll"
      >
        <template #header>
          <div class="table-header">
            <h5>Tipos de dispositivos</h5>
            <span>Número de dispositivos {{ lstDispositivos ? lstDispositivos.length : 0 }}</span>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                type="text"
                v-model="filters['global'].value"
                placeholder="Buscar..."
              />
            </span>
          </div>
        </template>
        <template #empty> No se encontrarón registros. </template>
        <template #loading> Cargando datos. Espere por favor. </template>
        <Column field="Descripcion" header="SERVCIO" sortable>
          <template #body="{data}"> {{ data.Descripcion }}</template>
        </Column>
        <Column field="Activo" header="ESTATUS" sortable>
          <template #body="slotProps">
            <span class="status-activo" v-show="slotProps.data.Estatus == 'ACTIVO'"> ACTIVO </span>
            <span class="status-inactivo" v-show="slotProps.data.Estatus == 'INACTIVO'"> INACTIVO </span>
          </template>
        </Column>
        <Column :exportable="false">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success"
              @click="edit(slotProps.data)"
            />
            <Button
              style="margin-left: 8px"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="borrar(slotProps.data)"
            />
          </template>
        </Column>
        <template #footer>
          Registros en total {{ lstDispositivos ? lstDispositivos.length : 0 }}
        </template>
      </DataTable>
  
      <Dialog :style="{ width: '600px' }" :visible="showAgregar" :modal="true" class="p-fluid" :closable="false">
        <template #header>
          <h3>{{ modoEdicion }} dispositivo</h3>
        </template>
  
        <div class="p-formgrid grid">
          <div class="p-field col">
            <label for="Dispositivo">Dispositivo</label>
            <InputText
              autocomplete="off"
              id="Producto"
              v-model.trim="dispositivo.Descripcion"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !dispositivo.Descripcion }"
            />
            <small class="p-invalid" v-if="submitted && !dispositivo.Descripcion">El dispositivo es requerido.</small>
          </div>
        </div>
  
        <div class="p-formgrid grid">
          <div class="p-field col">
            <div class="p-field-checkbox">
              <Checkbox
                id="Activo"
                name="Activo"
                :binary="true"
                v-model="dispositivo.Activo"
              />
              <label for="Activo"> Activo</label>
            </div>
          </div>
        </div>

        <template #footer>
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            @click="cancelarDialogo"
          />
          <Button
            label="Guardar"
            icon="pi pi-check"
            class="p-button-text"
            id="btnGuardar"
            @click="guardarDispositivo"
          />
        </template>
      </Dialog>
      <ConfirmDialog></ConfirmDialog>
    </div>
  </template>
  
  <script>
  import SCatalogos from "../service/Tipos_dispositivos";
  import { FilterMatchMode } from "primevue/api";
  import { ConfirmDialog } from 'primevue/confirmdialog';
  import {mapGetters} from 'vuex';
  
  export default {
    components: {
      ConfirmDialog
    },
    data() {
      return {
        Activo: false,
        Capitalizable: false,
        Salida_individual: false,
        lstUnidades: [],
        selectedUnidadFiltro: null,
        lstDispositivos: null,
        lstDispositivosO: null,
        lstTipos: null,
        lstModalidades: null,
        filters: {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
        filter: null,
        loading: true,
        submitted: false,
        showAgregar: false,
        dispositivoEdited: null,
        modoEdicion: "",
        dispositivo: {},
        img: "",
        mensajes:"",
        usuario: {},
        lstEstatus: [],
      };
    },
    created() {
      this.getDispositivos();
    },
    methods: {
      getDispositivos() {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
  
        CSrvr.getDispositivos(t)
          .then((res) => {
            t.lstDispositivos = res;
            t.loading = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            t.loading = false;
          });
      },
      getFechaWCF(fecha, hora) {
        if (fecha) {
          var millis = fecha
            .replace("/Date(", "")
            .replace("/", "")
            .replace(")", "");
  
          millis = millis * 1;
  
          if (millis > 0) {
            var mfecha = new Date(millis);
  
            var res =
              mfecha.getDate() < 10 ? "0" + mfecha.getDate() : mfecha.getDate();
            res += "/";
            res +=
              mfecha.getMonth() + 1 < 10
                ? "0" + (mfecha.getMonth() + 1)
                : mfecha.getMonth() + 1;
            res += "/";
            res += mfecha.getFullYear();
  
            if (hora) {
              res += " ";
              res += mfecha.getHours();
              res += ":";
              res +=
                mfecha.getMinutes() < 10
                  ? "0" + mfecha.getMinutes()
                  : mfecha.getMinutes();
            }
  
            return res;
          } else {
            return "N/D";
          }
        }
      },
      collapseAll() {
        this.expandedRows = null;
      },
      forzarUpdate() {
        this.$forceUpdate();
      },
      agregarDispositivo() {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
        CSrvr.getEstatus(t).then((res) => {
          t.lstEstatus = res;
          t.loading = false;
        });

        this.submitted = false;
        this.showAgregar = true;
        this.modoEdicion = "Agregar";
        this.mensajes = "";
        this.dispositivo.Activo = false;
      },
      cancelarDialogo() {
        this.submitted = false;
        this.showAgregar = false;
        this.modoEdicion = "";
        this.dispositivo = {};
        this.mensajes = "";
      },
      edit(obj) {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
        CSrvr.getEstatus(t).then((res) => {
          t.lstEstatus = res;
          t.loading = false;
        });
        this.dispositivo = { ...obj };
        this.showAgregar = true;
        this.modoEdicion = "Editar";
        if(obj.Estatus == "ACTIVO"){
          this.dispositivo.Activo = true;
        }
      },
      borrar(obj) {
        var t = this;      
        t.$confirm.require({
          message: '¿Quiere desactivar el dispositivo?',
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Sí, eliminar',
          rejectLabel: 'Cancelar',
          acceptClass: 'p-button-danger',
          accept: () => {
            var val = obj;
            var ctlSvr = new SCatalogos();

            ctlSvr.getEstatus(t).then((res) => {
              t.lstEstatus = res;
              t.loading = false;

              obj.Activo = false;
              obj.Estatus = "INACTIVO";
              obj.Usuario_modificacion = t.getUsuarioLogueado.Usuario.Usuario;

              const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
              if (estatusEncontrado) {
                obj.Id_estatus = estatusEncontrado.Id_estatus;
              }
              
              ctlSvr.updateDispositivo(t, val).then(() => {
                t.$toast.add({
                  severity: "success",
                  summary: "AVISO",
                  detail: "Insumo eliminado correctamente",
                  life: 3000,
                });
                t.getDispositivos();
              });
            });
          },
          reject: () => {
            // Usuario canceló
          }
        });
      },
      guardarDispositivo() {
        var t = this;
        this.submitted = true;
        const usuario = t.getUsuarioLogueado.Usuario.Usuario;

        if (!t.dispositivo || !t.dispositivo.Descripcion) {
          t.mensajes = "Algunos campos faltantes son obligatorios";
          return;
        }
  
        if (t.dispositivo.Activo == false) {
          t.dispositivo.Estatus = "INACTIVO";

          const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
          if (estatusEncontrado) {
            t.dispositivo.Id_estatus = estatusEncontrado.Id_estatus;
          }

        } else {
          t.dispositivo.Estatus = "ACTIVO";

          const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "ACTIVO");
          if (estatusEncontrado) {
            t.dispositivo.Id_estatus = estatusEncontrado.Id_estatus;
          }
        }

        t.dispositivo.Usuario_creacion = usuario;

        this.sendRequest(t, t.dispositivo);
      },
      sendRequest(t, obj){
        var CSrvr = new SCatalogos();
          if (t.modoEdicion == "Agregar") {
            CSrvr.addDispositivo(t, obj).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Insumo agregado correctamente",
                life: 3000,
              });
              t.cancelarDialogo();
              t.getDispositivos();
            });
          } else {
            obj.Usuario_modificacion = t.getUsuarioLogueado.Usuario.Usuario;

            if (obj.Activo == false) {
            obj.Estatus = "INACTIVO";

            const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
            if (estatusEncontrado) {
              obj.Id_estatus = estatusEncontrado.Id_estatus;
            }

            } else {
              obj.Estatus = "ACTIVO";

              const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "ACTIVO");
              if (estatusEncontrado) {
                obj.Id_estatus = estatusEncontrado.Id_estatus;
              }
            }
            
            CSrvr.updateDispositivo(t, obj).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Insumo editado correctamente",
                life: 3000,
              });
              t.cancelarDialogo();
              t.getDispositivos();
            });
          }
      }
    },
    computed:{
      ...mapGetters(['getUrlDispositivos','getUsuarioLogueado']),  
    },       
  };
  </script>
  
  <style scoped>
  .table-header {
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
  }
  .title {
    font-weight: 700;
    letter-spacing: 0.3px;
    margin-right: 10px;
    text-transform: uppercase;
  }
  .data {
    letter-spacing: 0.3px;
    margin-right: 10px;
    letter-spacing: 0.5px;
  }
  .product-image {
    width: 100px;
  }
  </style>
  